// Manual CAD (FreeCAD-style) feature catalogue — the closed, whitelisted set of
// operations the Manual mode exposes. Shared by the toolbar feature bar
// (<ManualCadFeatureBar>) and the sidebar tree (<ManualCadContent>) so the two
// can never drift. Keeping this a typed config (not free strings) is also the
// security boundary the backend enforces: only these `type`s are accepted, and
// each maps to server-side template codegen — never user-authored code.
// See docs/freecad-manual-cad-integration-plan.md §4.1 / §8.

export type ManualFeatureType =
  | 'Sketch'
  | 'Pad'
  | 'Pocket'
  | 'Fillet'
  | 'Chamfer'
  | 'Boolean';

export interface ManualFeatureDef {
  type: ManualFeatureType;
  label: string;
  /** One-line description surfaced in the button tooltip. */
  hint: string;
}

export const MANUAL_FEATURES: ManualFeatureDef[] = [
  { type: 'Sketch', label: 'Sketch', hint: 'Start a 2D profile on a plane' },
  { type: 'Pad', label: 'Pad', hint: 'Extrude a sketch into a solid' },
  { type: 'Pocket', label: 'Pocket', hint: 'Cut a sketch into a solid' },
  { type: 'Fillet', label: 'Fillet', hint: 'Round selected edges' },
  { type: 'Chamfer', label: 'Chamfer', hint: 'Bevel selected edges' },
  { type: 'Boolean', label: 'Boolean', hint: 'Cut / union / intersect bodies' },
];
